export default __webpack_public_path__ + "static/media/Vazir-Thin.e3f8d0d5.ttf";